import Layout from '../components/Layout'
import { PageHeader, Section, Card } from '../components/UIComponents'

export default function Apps() {
  return (
    <Layout>
      <div className="space-y-8 max-w-6xl mx-auto">
        <PageHeader
          icon="📱"
          title="Apps"
          description="Aplicaciones y integraciones disponibles"
        />

        <Section title="Apps Disponibles">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {[
              { name: 'Uniswap', desc: 'DEX de intercambio', icon: '🔄' },
              { name: 'Curve', desc: 'Stableswap DEX', icon: '📈' },
              { name: 'Aave', desc: 'Lending Protocol', icon: '💳' },
              { name: 'OpenSea', desc: 'Marketplace de NFTs', icon: '🎨' },
              { name: 'Lido', desc: 'Liquid Staking', icon: '🔗' },
            ].map((app, i) => (
              <Card key={i} className="hover:border-blue-500 transition-colors">
                <div className="space-y-3">
                  <div className="text-4xl">{app.icon}</div>
                  <h3 className="text-white font-semibold">{app.name}</h3>
                  <p className="text-slate-400 text-sm">{app.desc}</p>
                  <button className="w-full px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold rounded-lg transition-colors">
                    Conectar
                  </button>
                </div>
              </Card>
            ))}
          </div>
        </Section>

        <Section title="Próximamente">
          <Card>
            <div className="text-center py-8">
              <p className="text-slate-400">Más apps integrando...</p>
            </div>
          </Card>
        </Section>
      </div>
    </Layout>
  )
}
